module.exports = " <div role=tabpanel v-if=selected :class=\"{ 'tab-pane': true, 'animated': true, 'is-active': selected, 'is-deactive': !selected }\" :aria-labelledby=label :aria-hidden=hidden :transition=transition :transition-mode=transitionMode> <slot></slot> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-bulma-tabs/src/TabPane.vue
// module id = 934
// module chunks = 2